"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ModalManagerComponent = /** @class */ (function (_super) {
    __extends(ModalManagerComponent, _super);
    function ModalManagerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalManagerComponent.prototype.render = function () {
        var x = this.props.modals;
        if (x.length == 0) {
            return null;
        }
        else {
            //Solo mostramos el ultimo modal, se van a mostrar los demas modales después de que se cierre este
            var _a = x[x.length - 1], component = _a.component, props = _a.props;
            var Comp = component;
            return React.createElement(Comp, __assign({}, props));
        }
    };
    return ModalManagerComponent;
}(React.PureComponent));
exports.ModalManagerComponent = ModalManagerComponent;
//# sourceMappingURL=component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-modal-manager/dist/component.js
// module id = 2484
// module chunks = 0